export const promotion_types_constants = {
    ORDER_BUMPS: 1,
    THANK_YOU_PAGE: 2,
    UPSELL: 3,
};
